/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Plan_ProInputs */

const en_settings_plan_pro = /** @type {(inputs: Settings_Plan_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const de_settings_plan_pro = /** @type {(inputs: Settings_Plan_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const fr_settings_plan_pro = /** @type {(inputs: Settings_Plan_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const es_settings_plan_pro = /** @type {(inputs: Settings_Plan_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const it_settings_plan_pro = /** @type {(inputs: Settings_Plan_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const nl_settings_plan_pro = /** @type {(inputs: Settings_Plan_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const pl_settings_plan_pro = /** @type {(inputs: Settings_Plan_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const fi_settings_plan_pro = /** @type {(inputs: Settings_Plan_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const da_settings_plan_pro = /** @type {(inputs: Settings_Plan_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const sv_settings_plan_pro = /** @type {(inputs: Settings_Plan_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

/**
* | output |
* | --- |
* | "Pro" |
*
* @param {Settings_Plan_ProInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_plan_pro = /** @type {((inputs?: Settings_Plan_ProInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Plan_ProInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_plan_pro(inputs)
	if (locale === "fr") return fr_settings_plan_pro(inputs)
	if (locale === "es") return es_settings_plan_pro(inputs)
	if (locale === "it") return it_settings_plan_pro(inputs)
	if (locale === "nl") return nl_settings_plan_pro(inputs)
	if (locale === "pl") return pl_settings_plan_pro(inputs)
	if (locale === "fi") return fi_settings_plan_pro(inputs)
	if (locale === "da") return da_settings_plan_pro(inputs)
	if (locale === "sv") return sv_settings_plan_pro(inputs)
	return en_settings_plan_pro(inputs)
});